{
  "schedule": {
    "completed": [
      {
        "id": "completed-1",
        "patientName": "Rafael Torres",
        "time": "8:40 AM",
        "languageDialect": "Spanish",
        "sourceLabel": "Scribe",
        "modalityLabel": "Scribe",
        "durationLabel": "18 min",
        "accentKey": "scribe",
        "detailLine": "Started by Dr. Singh · Family Medicine",
        "conversationSummary": "Follow-up note completed for medication review and blood pressure plan."
      },
      {
        "id": "completed-2",
        "patientName": "Nadia Petrov",
        "time": "9:05 AM",
        "languageDialect": "Russian",
        "sourceLabel": "Interpreter",
        "modalityLabel": "Interpreter",
        "durationLabel": "12 min",
        "accentKey": "interpreter",
        "detailLine": "Started by Dr. Gomez",
        "conversationSummary": "Completed interpretation for care instructions and discharge questions."
      }
    ],
    "noShows": [
      {
        "id": "no-show-1",
        "patientName": "Maya Rodriguez",
        "time": "9:20 AM",
        "languageDialect": "Spanish",
        "sourceLabel": "EHR",
        "statusLabel": "No-show",
        "accentKey": "noShow",
        "detailLine": "Dr. Patel · Room 4 · Follow-up visit"
      },
      {
        "id": "no-show-2",
        "patientName": "Daniel Kim",
        "time": "10:05 AM",
        "languageDialect": "Korean",
        "sourceLabel": "EHR",
        "statusLabel": "No-show",
        "accentKey": "noShow",
        "detailLine": "Dr. Patel · Telehealth · Lab review"
      }
    ],
    "incomplete": [
      {
        "id": "incomplete-1",
        "patientName": "Amina Hassan",
        "time": "11:30 AM",
        "elapsedMinutes": 30,
        "languageDialect": "Arabic",
        "sourceLabel": "Interpreter",
        "modalityLabel": "Interpreter",
        "durationLabel": "30 min recorded",
        "accentKey": "interpreter",
        "detailLine": "Started by Dr. Singh · 2 contributors",
        "isTelehealth": false,
        "conversationSummary": "Reviewed symptoms and medication timing. Confirmed Arabic interpretation preference. Discussed next care steps."
      }
    ],
    "upcoming": [
      {
        "id": "upcoming-1",
        "patientName": "Lucia Moreno",
        "time": "1:15 PM",
        "languageDialect": "Spanish",
        "sourceLabel": "EHR",
        "statusLabel": "Appointment",
        "accentKey": "ehr",
        "detailLine": "Dr. Patel · Main Clinic · Diabetes follow-up"
      },
      {
        "id": "upcoming-2",
        "patientName": "Wei Chen",
        "time": "2:40 PM",
        "languageDialect": "Mandarin",
        "sourceLabel": "EHR",
        "statusLabel": "Appointment",
        "accentKey": "ehr",
        "detailLine": "Dr. Lee · Room 2 · New patient"
      },
      {
        "id": "upcoming-3",
        "patientName": "Jean Baptiste",
        "time": "4:10 PM",
        "languageDialect": "Haitian Creole",
        "sourceLabel": "Scheduled bot",
        "modalityLabel": "Interpreter",
        "statusLabel": "Scheduled",
        "accentKey": "interpreter",
        "isTelehealth": true,
        "detailLine": "zoom.us · Video interpretation"
      }
    ]
  }
}
